import { FormattedMessage, useIntl } from 'react-intl'
import { Box, styled } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'
import ConnectionsNewButton from 'features/connections/ui/ConnectionsNewButton'
import { AddOutlined } from '@mui/icons-material'
import dotsBgConnections from 'assets/img/dots-bg-connections.png'

const Root = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(4),
  flexDirection: 'column',
  alignItems: 'flex-start',
  backgroundColor: theme.palette.brand.navyBlue,
  color: theme.palette.common.white,
  minHeight: theme.spacing(35),
  backgroundImage: `url('${dotsBgConnections}')`,
  backgroundSize: 'auto 100%',
  backgroundPosition: 'right center',
  backgroundRepeat: 'no-repeat',
  borderRadius: theme.shape.borderRadius
}))

export function HomeOnboardingDataWarehouse() {
  const intl = useIntl()

  return (
    <Root p={4}>
      <Typography component="h3" variant="h5" color="inherit" mb={2}>
        <FormattedMessage id="home.onboarding.dataWarehouse.title" />
      </Typography>
      <Typography variant="body1" maxWidth="58%" flex="1 1 auto" mb={2} color={(theme) => theme.palette.white[68]}>
        <FormattedMessage id="home.onboarding.dataWarehouse.content" />
      </Typography>
      <ConnectionsNewButton
        label={intl.formatMessage({ id: 'home.onboarding.dataWarehouse.button' })}
        icon={<AddOutlined />}
      />
    </Root>
  )
}

export default HomeOnboardingDataWarehouse
